import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {Agent} from "../../models/Agent";
import {setSelectedConversationId} from "./conversations.slice";
import {AgentBasicDto} from "../../dto/AgentBasicDto"; // Pfad ggf. anpassen

export interface AgentsState {
    agents: Agent[],
    selectedAgent: Agent | null,
    selectedAgentIndex: number | null,
}

const initialState: AgentsState = {
    agents: [],
    selectedAgent: null,
    selectedAgentIndex: null,
}

const getAgentIndex = (agents: Agent[], agent: Agent) => {
    return agents.findIndex(a => a.id === agent.id);
}

export const agentsSlice = createSlice({
    name: 'agents',
    initialState,
    reducers: {
        setAgents(state, action) {
            state.agents = action.payload;

        },
        clearAgents(state) {
            state.agents = [];
            state.selectedAgent = null;
            state.selectedAgentIndex = null;
        },
        setSelectedAgent(state, action) {
            if (!state.selectedAgent || state.selectedAgent.gcpAgentId !== action.payload.gcpAgentId) {
                state.selectedAgent = action.payload;
                state.selectedAgentIndex = getAgentIndex(state.agents, action.payload);
            }
        },
        clearSelectedAgent(state) {
            state.selectedAgent = null;
            state.selectedAgentIndex = null;
        },
        updateAgent(state, action) {
            const updated = action.payload as AgentBasicDto;
            const index = state.agents.findIndex(agent => agent.gcpAgentId === updated.gcpAgentId);
            if (index !== -1) {
                state.agents[index] = {
                    ...state.agents[index],
                    gcpName: updated.agentDisplayName
                };
            }
        }
    },
})

export const setActiveAgent = createAsyncThunk<void, Agent>(
    'agents/setActiveAgent',
    async (agent, {dispatch}) => {
        dispatch(setSelectedAgent(agent));
        dispatch(setSelectedConversationId(null)); // Conversation zurücksetzen
    }
);

// Action creators are generated for each case reducer function
export const {setAgents, clearAgents, setSelectedAgent, clearSelectedAgent, updateAgent} = agentsSlice.actions

export default agentsSlice.reducer